export const TRANSACTION_CARD_CLASSES = {
  container: 'w-full rounded-[13px] bg-od-bg-secondary p-px',
  // Vertical on mobile (image stacked above the body, per the Figma mobile
  // spec) and horizontal on desktop (image left, body right).
  innerCard:
    'w-full flex-col overflow-hidden rounded-xl bg-od-bg-primary shadow-[0_0_0_1px_rgba(121,118,117,0.16)] md:flex-row md:items-stretch',
  mediaSlot:
    // 5:2 banner on mobile (image stacks full-width) so the media stays short as
    // the card width changes; a fixed 197x131 slot on desktop. `overflow-hidden`
    // + object-cover on the child crop the (taller) photo to the slot, and
    // `shrink-0` stops the flex column from squashing the derived height.
    'relative aspect-[5/2] w-full shrink-0 overflow-hidden rounded-xl md:aspect-auto md:h-[131px] md:w-[197px]',
  body: 'min-w-0 flex-1 items-start gap-4 px-4 pt-3 pb-4 md:flex-row md:items-center md:gap-4 md:px-5 md:py-3',
  details: 'min-w-0 flex-1 justify-center gap-1',
  // Mobile-only divider between the details and the progress row; desktop
  // keeps the body's horizontal layout, so the rule is hidden there.
  divider: 'h-px w-full bg-od-border-primary md:hidden',
  status: 'shrink-0 items-center gap-2 md:flex-col md:items-end',
  footer: 'items-center justify-between gap-4 px-4 py-3',
  footerMessage:
    // Mobile shows the full task copy, wrapping to as many lines as needed;
    // desktop keeps it to two lines so the card stays compact next to the CTA.
    'min-w-0 flex-1 text-body-sm text-od-content-primary md:line-clamp-2 md:text-body-md',
  ctaSkeleton: 'h-11 w-[104px] shrink-0 skeleton rounded-2xl bg-od-bg-tertiary',
} as const;
